import { styled } from "styled-components";

export const NumberPickerFooterWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const NumberPickerFooterContainer = styled.div`
  display: flex;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 96px;
  padding: 48px 24px;
`;

export const NumberPickerFooterTitle = styled.p`
  color: ${({ theme }) => theme.colors.default[600]};
  padding: 0px 16px;
  font-size: 17px;
  font-style: normal;
  font-weight: 550;
  line-height: 150%; /* 25.5px */

  & > a {
    color: ${({ theme }) => theme.colors.primary.default};
  }
`;

export const NumberPickerFooterLinks = styled.div`
  display: flex;
  max-width: 973px;
  padding: 48px;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  width: 100%;
  border-radius: 24px;
  background: ${({ theme }) => theme.colors.default[50]};
`;

export const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  align-self: stretch;

  & > p {
    color: ${({ theme }) => theme.colors.default[600]};
  }
`;

export const LinksSection = styled.div`
  display: flex;
  min-height: 120px;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 24px 32px;
  align-self: stretch;
  flex-wrap: wrap;

  & > button {
    width: 191px;
  }
`;

export const FooterLink = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  color: ${({ theme }) => theme.colors.default[600]};
`;
